import { getTrades } from "@/Groups/Polymarket/private/api/getTrades";

const Polymarket = {
  namespaced: true,

  state: {
    data: [],
    map: [],
    next: null,
    isReady: false,
    isLoadingNext: false,
  },

  actions: {
    async init({ state, commit }){
      const data = await getTrades();
      console.log(data)
      commit('SET_DATA', data.results);
      commit('SET_NEXT', data.next);
      commit('SET_READY_FLAG', true);
      console.log(state.data);
      console.log(state.map);
    },

    async loadNext({ state, commit }){
      commit('SET_IS_LOADING_NEXT', true);
      const data = await getTrades({ url: state.next });
      console.log(data)
      commit('SET_DATA', data.results);
      commit('SET_NEXT', data.next);
      commit('SET_IS_LOADING_NEXT', false);
    },

    async toggleFilter({ commit, dispatch }, filterName){
      if (this.state.Polymarket.activeFilter === filterName) {
        await dispatch('resetFilter');
        return;
      }
      commit('SET_LOADING_FILTER', true);
      commit('SET_ACTIVE_FILTER', filterName);
      try {
        const data = await getTrades({ [filterName]: true });
        commit('CLEAR_DATA');
        commit('SET_DATA', data.results);
        commit('SET_NEXT', data.next);
      } catch (error) {
        console.error('Ошибка при загрузке фильтра:', error);
        commit('SET_ACTIVE_FILTER', null);
      } finally {
        commit('SET_LOADING_FILTER', false);
      }
    },

    async resetFilter({ commit }){
      commit('SET_LOADING_FILTER', true);
      commit('SET_ACTIVE_FILTER', null);
      try {
        const data = await getTrades();
        commit('CLEAR_DATA');
        commit('SET_DATA', data.results);
        commit('SET_NEXT', data.next);
      } catch (error) {
        console.error('Ошибка при сбросе фильтра:', error);
      } finally {
        commit('SET_LOADING_FILTER', false);
      }
    }
  },

  mutations: {
    SET_DATA(state, data) {
      data.forEach((trade) => {
        state.data[trade.id] = {
          ...(state.data[trade.id] || {}),
          ...trade,
        };
        if (!state.map.includes(trade.id)) {
          state.map.push(trade.id);
        }
      });
    },

    SET_READY_FLAG(state, status){
      state.isReady = status;
    },

    SET_NEXT(state, nextUrl){
      state.next = nextUrl;
    },

    SET_ACTIVE_FILTER(state, filterName) {
      state.activeFilter = filterName;
    },

    SET_LOADING_FILTER(state, status) {
      state.isLoadingFilter = status;
    },

    CLEAR_DATA(state) {
      state.data = [];
      state.map = [];
      state.next = null;
    }
  },

  getters: {
   //Получить все торговые операции в виде массива
    allTrades: (state) => { return state.data; },

    //Получить торговую операцию по ID
    tradeById: (state) => (id) => { return state.data[id] || null; },

    //Получить количество торговых операций
    tradesMap: (state) => { return state.map; },

    //Проверить, загружены ли данные
    isReady: (state) => { return state.isReady; },

    //Подгружается ли следующая страница с данными
    isLoadingNext: (state) => { return state.isLoadingNext; },

    //Url следующей страницы
    nextUrl: (state) => { return state.next; },

    //Получить активный фильтр
    activeFilter: (state) => { return state.activeFilter; },

    //Идет ли загрузка данных по фильтру
    isLoadingFilter: (state) => { return state.isLoadingFilter; },
  }
}

export default Polymarket;